import { useUserRealtime } from "@/hooks/useUserRealtime";
import { useNotificationContext } from "@/contexts/NotificationContext";
import { useReminderContext } from "@/contexts/ReminderContext";
import { toast } from "@/lib/toast";

export function NotificationToast() {
	const { pushNotification } = useNotificationContext();
	const { triggerReminder } = useReminderContext();

	useUserRealtime({
		onNotificationCreated: (payload) => {
			pushNotification({
				id: payload.id,
				userId: payload.userId,
				type: payload.type as "quiz_reminder" | "partner_answered" | "streak_risk" | "system",
				title: payload.title,
				body: payload.body,
				createdAt: payload.createdAt ?? Date.now(),
			});

			if (payload.type === "system" && payload.title.startsWith("Pengingat:")) {
				let reminderId: string | undefined;
				if (payload.data) {
					try {
						const parsed = JSON.parse(payload.data);
						reminderId = parsed.reminderId;
					} catch { /* ignore */ }
				}
				triggerReminder({
					id: payload.id,
					reminderId,
					title: payload.title.replace("Pengingat: ", ""),
					body: payload.body,
				});
			} else {
				toast.info(payload.title, { description: payload.body });
			}
		},
	});

	return null;
}
